import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PersonFormVM } from '../person/form';
import TableFamilyForm from './table-family';
import { FamilyVM } from './family-vm';

interface AccordionFormFamilyProps {
  formContext: FormikProps<{
    family: Array<FamilyVM>;
    person?: PersonFormVM;
  }>;
}

const AccordionFamilyComponent = ({
  formContext,
}: AccordionFormFamilyProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-family-practice-content"
          id="panel-family-practice-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Famiglia</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableFamilyForm
            values={formContext.values.family}
            onChange={(values) => formContext.setFieldValue('family', values)}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFamilyComponent.displayName = 'Accordion Family component';

const AccordionFamily = memo(AccordionFamilyComponent);

export default AccordionFamily;
